import router from "@/router";

//Toast to show if login isn't successfull
export function logOut() {
    localStorage.clear();
    // Forza il reindirizzamento alla pagina di login
    router.replace("/login");
}


